/**
 * Named starting settings for Penelope. A preset is a partial config applied
 * on top of the relay's defaults when a game is attached (ticket, strip) or
 * pasted into an attached game's settings. Researchers keep their own presets
 * in the browser (PenelopeSettings → copy / paste JSON); these two are the
 * desk's.
 */
import type { PenelopeConfig } from '@/hooks/usePenelope';

export interface PenelopePreset {
  key: string;
  label: string;
  hint: string;
  config: Partial<PenelopeConfig>;
}

/** Starting settings of a one-click run (Josh, 2026-10-06): 10 a clip, 2¢ to add, 1¢ to sell it back. Max Long and Max
 *  Gross are the relay's default — 10,000 (Doom baseline 10-20, PR-005), clamped to the box's ceiling — so the draft
 *  never names a size this box would refuse. Everything else is the relay's default; all of it is editable once
 *  she is attached. */
export const PENELOPE_START: Partial<PenelopeConfig> = {
  mode: 'shadow', lean: 'neutral', clipContracts: 10,
  minEdgeCents: 2, cancelEdgeCents: 1,
};

/** The same start, with every thin-book guard set to stay resting (Josh, 2026-10-07): hold through a one-sided or
 *  quiet book, no depth-dropout pull, and the book-stale bound at the subscription-dead level. */
export const PENELOPE_HOLD_THIN: Partial<PenelopeConfig> = {
  ...PENELOPE_START, liquidityGatePolicy: 'hold', depthDropPct: 0, bookStaleMs: 600_000,
};

export const PENELOPE_PRESETS: PenelopePreset[] = [
  { key: 'start', label: 'start', hint: 'Josh’s one-click start: Contract Size 10, Max Long the box default (10,000), 2¢ to add, 1¢ to sell back; thin books hold.', config: PENELOPE_START },
  { key: 'holdThin', label: 'hold through thin books', hint: 'The start, plus: never pull on a depth dropout, book-stale at 600 s. The stance for liquidity leaving the book.', config: PENELOPE_HOLD_THIN },
];
